module.exports = __webpack_public_path__ + "static/media/carta_79.0c0cc7e7.jpg";